export default {
  title: {
    id: 'review_ai_highlights_title',
    defaultMessage: 'Highlighted by customers',
  },
  tooltipInfoLatestReviews: {
    id: 'review_ai_highlights_tooltip_latest_reviews',
    defaultMessage:
      'Customer highlights are top mentions that come from the most recent {number} reviews, updated {updateDate}.',
  },
  tooltipInfoAllReviews: {
    id: 'review_ai_highlights_tooltip_all_reviews',
    defaultMessage:
      'Customer highlights are top mentions that come from all reviews, updated {updateDate}.',
  },
} as const
